import MuiTableRow from '@material-ui/core/TableRow';
import MuiTableCell from '@material-ui/core/TableCell';

const FullColSpanRow = ({ row }) => {
  return (
    <MuiTableRow>
      <MuiTableCell colSpan={100}>{row.Component}</MuiTableCell>
    </MuiTableRow>
  );
};

export default FullColSpanRow;
